<template>
  <v-dialog
    v-model="active"
    width="50%"
    :persistent="running"
    transition="scale-transition"
  >
    <v-card rounded white>
      <v-card-title class="rtl primary white--text">
        {{ title }}
      </v-card-title>
      <v-card-text class="text-center mt-4">
        <div v-if="logs.length" class="job-logs" dir="rtl">
          <div
            v-for="(log, index) in logs"
            :key="index"
            class="job-log"
            :class="'job-log--' + (log.level || 'info')"
          >
            <div>{{ log.message }}</div>
            <div v-if="logDetail(log)" class="job-log-detail">{{ logDetail(log) }}</div>
          </div>
        </div>
        <div class="content-area" :class="{ running }">
          <transition name="fade" mode="out-in">
            <div v-if="running" key="running" class="content-inner">
              <transition name="fade">
                <v-progress-linear
                  v-if="progress !== null"
                  :value="progress"
                  height="8"
                  rounded
                  color="primary"
                ></v-progress-linear>
              </transition>
            </div>
            <div v-else-if="success" key="success" class="content-inner">
              <p class="mb-3">{{ successMessage }}</p>
              <v-btn color="success" @click="close">סגור</v-btn>
            </div>
            <div v-else-if="error" key="error" class="content-inner">
              <p class="mb-3 error--text">{{ errorMessage }}</p>
              <v-btn color="error" @click="close">סגור</v-btn>
            </div>
          </transition>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
const DEFAULT_SUCCESS_MESSAGE = "פעולה הסתימה בהצלחה";

export default {
  name: "LongActionModal",
  data() {
    return {
      active: false,
      title: "",
      progress: null,
      success: false,
      error: false,
      errorMessage: "",
      successMessage: DEFAULT_SUCCESS_MESSAGE,
      running: false,
      logs: []
    };
  },
  watch: {
    active(visible) {
      if (!visible) {
        this.reset();
      }
    }
  },
  methods: {
    reset() {
      this.progress = null;
      this.success = false;
      this.error = false;
      this.errorMessage = "";
      this.successMessage = DEFAULT_SUCCESS_MESSAGE;
      this.running = false;
      this.logs = [];
    },
    logDetail(log) {
      const attributes = (log && log.attributes) || {};
      const parts = [];
      if (attributes.form) parts.push(attributes.form);
      if (attributes.folder) parts.push(attributes.folder);
      if (attributes.filename) parts.push(attributes.filename);
      if (attributes.field) parts.push(attributes.field);
      if (attributes.length != null && attributes.maxLength != null) {
        parts.push(attributes.length + "/" + attributes.maxLength);
      }
      if (attributes.detail) parts.push(attributes.detail);
      return parts.join(" · ");
    },
    close() {
      this.active = false;
    },
    clampProgress(percent) {
      if (percent == null || typeof percent !== "number") return null;
      return Math.min(100, Math.max(0, percent));
    },
    run(title, promiseOrFactory, options = {}) {
      this.reset();
      this.title = title || "מבצע פעולה...";
      this.active = true;
      this.running = true;

      const updateProgress = (percent) => {
        if (percent && typeof percent === "object") {
          if (Array.isArray(percent.logs)) this.logs = percent.logs;
          const v = this.clampProgress(percent.progress);
          if (v !== null) this.progress = v;
          return;
        }
        const v = this.clampProgress(percent);
        if (v !== null) this.progress = v;
      };

      const runPromise = () => {
        const promise =
          typeof promiseOrFactory === "function"
            ? promiseOrFactory(updateProgress)
            : promiseOrFactory;

        if (!promise || typeof promise.then !== "function") {
          this.running = false;
          this.error = true;
          this.errorMessage = "Invalid promise or factory return value";
          return;
        }

        promise
          .then(async (result) => {
            this.running = false;
            this.success = true;
            if (options.onSuccess) {
              try {
                const ret = options.onSuccess(result);
                const msg =
                  ret && typeof ret.then === "function" ? await ret : ret;
                if (msg != null && msg !== "")
                  this.successMessage = String(msg);
              } catch (e) {
                this.successMessage = DEFAULT_SUCCESS_MESSAGE;
              }
            }
            this.$emit("success");
          })
          .catch((err) => {
            this.running = false;
            this.error = true;
            if (Array.isArray(err?.logs) && err.logs.length) {
              this.logs = err.logs;
            }
            if (options.onFailure) {
              try {
                const msg = options.onFailure(err);
                if (msg != null && msg !== "") this.errorMessage = String(msg);
                else this.errorMessage = err?.message || String(err);
              } catch (e) {
                this.errorMessage = err?.message || String(err);
              }
            } else {
              this.errorMessage = err?.message || String(err);
            }
            this.$emit("error", err);
          });
      };

      this.$nextTick(runPromise);
    }
  }
};
</script>

<style scoped>
.content-area {
  transition: max-height 1s ease;
}
.job-logs {
  max-height: 240px;
  overflow: auto;
  text-align: right;
  margin-bottom: 12px;
}
.job-log {
  font-size: 14px;
  line-height: 1.4;
  margin-bottom: 8px;
}
.job-log--error {
  color: #c62828;
}
.job-log--warning {
  color: #ef6c00;
}
.job-log-detail {
  font-size: 13px;
  color: rgba(0, 0, 0, 0.7);
}
.content-area.running {
  max-height: 24px;
}
.content-area:not(.running) {
  max-height: 80px;
}
.content-inner {
  min-height: 24px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
